import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsBadgeHighlightedSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 12.93l-4.1 2.37c-.15.09-.34.09-.5 0l-4.1-2.37v10.24c0 .18.1.34.25.43.08.04.17.07.25.07.09 0 .18-.03.25-.07l3.6-2.08 3.6 2.08c.16.09.35.09.5 0 .16-.09.25-.25.25-.43zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.51 10.54c0 .18-.1.35-.25.43L12.5 14.3c-.15.09-.34.09-.5 0l-5.75-3.33a.492.492 0 01-.25-.43V3.9c0-.18.1-.35.25-.43L12 .14a.55.55 0 01.5 0l5.76 3.33c.15.08.25.25.25.43zm0 0",
    fillRule: "evenodd"
  }));
});
SvgAchievementsBadgeHighlightedSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsBadgeHighlightedSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsBadgeHighlightedSmall;